import React, { useEffect, useState } from 'react'
import '../styles/Ecosistemas.css'
import { EcosistemasCards } from './EcosistemasCards'
import AliceCarousel from 'react-alice-carousel'
import { ButtonNext, ButtonPrevious } from '../../../../assets/icons/Icons'

export const Ecosistema = ({ecosistemas}) => {

    const [ecosistema, setEcosistema] = useState()

    const responsive = {
        320:{
          items: 1
        },
        576: { 
            items: 2
        },
        768:{
            items: 2
        },
        992:{
            items: 3
        },
        1200:{
            items: 4
        },
        1400:{
            items: 4
        },
        1600:{
            items: 5
        },
        1800:{
            items: 5
        }
    };

    useEffect(() => {
        if (ecosistemas?.length < 1 || ecosistemas === undefined) return
        let arregloEcosistema = []
        ecosistemas.forEach(element => {
          arregloEcosistema.push(<EcosistemasCards ecosistema={element} />)
        })
        setEcosistema(arregloEcosistema)
    }, [ecosistemas])

  return (
    <>
        <div id="ecosistemas">
            <div className='banner__ecosistemas bg-verde-1 ' >
                <h2>Tu ecosistema</h2>
                <p className='mt-4'>Tu seguro viene acompañado de un ecosistema de beneficios adicionales.<br/>Activa tu cuenta y comienza a disfrutar de ellos.</p>
            </div>
            <div className='container'>
                {
                    ecosistema?.length > 0 && (
                    <AliceCarousel
                        mouseTracking 
                        items={ecosistema} 
                        responsive={responsive}
                        centerMode={true}
                        disableDotsControls
                        infinite={true}
                        renderPrevButton={() => {
                            return <div className='btn__prev__ecosistemas '  ><ButtonPrevious /></div>
                        }}
                        renderNextButton={() => {
                            return <div className='btn__next__ecosistemas'><ButtonNext /></div>
                        }}
                    />
                    )
                }
            </div>
            {/* <EcosistemasCards ecosistemas={ecosistemas} /> */}
        </div>
    </>
  )
}
